import React from "react";

export default function Silang({
  fill = "white",
  width = "10",
  height = "10",
  ...others
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...others}>
      <path
        d='M9.99952 1.00248C9.99952 0.737399 9.89424 0.483167 9.70681 0.295697C9.61394 0.202599 9.50362 0.126736 9.38216 0.0763384C9.2607 0.0259408 9.13049 0 8.99899 0C8.86749 0 8.73728 0.0259408 8.61582 0.0763384C8.49436 0.126736 8.38404 0.200599 8.29117 0.293697L5 3.58669L1.70883 0.293697C1.52111 0.105981 1.2665 0.000523408 1.00101 0.000523408C0.735526 0.000523408 0.480915 0.105981 0.293189 0.293697C0.105464 0.481413 0 0.736011 0 1.00148C0 1.26695 0.105464 1.52155 0.293189 1.70927L3.58636 5.00026L0.293189 8.29126C0.200237 8.38421 0.126503 8.49455 0.0761975 8.61599C0.025892 8.73743 0 8.86759 0 8.99904C0 9.13049 0.025892 9.26065 0.0761975 9.38209C0.126503 9.50354 0.200237 9.61388 0.293189 9.70683C0.386142 9.79977 0.496492 9.8735 0.61794 9.92381C0.739388 9.97411 0.869556 10 1.00101 10C1.13247 10 1.26263 9.97411 1.38408 9.92381C1.50553 9.8735 1.61588 9.79977 1.70883 9.70683L5 6.41383L8.29117 9.70683C8.4789 9.89454 8.73351 10 8.99899 10C9.26447 10 9.51909 9.89454 9.70681 9.70683C9.89454 9.51911 10 9.26451 10 8.99904C10 8.73357 9.89454 8.47897 9.70681 8.29126L6.41364 5.00026L9.70681 1.70927C9.89424 1.5218 9.99952 1.26757 9.99952 1.00248Z'
        fill={fill}
      />
    </svg>
  );
}
